
        var result = require("!!../../../../../node_modules/css-loader/index.js!./product-detail.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/products/product-detail/product-detail.component.css
// module id = 559
// module chunks = 0